// HowWeWork section — 8 languages
export const howWeWorkI18n = {
  ru: {
    eyebrow: 'Process',
    title: 'Этапы нашей работы с вами',
    subtitle: 'Команда STUDYGRI берёт на себя всю работу — от первой консультации до начала учёбы',
    seeAll: 'Смотреть все 18 шагов нашего процесса',
    steps: [
      { title: 'ЗНАКОМСТВО И ДОГОВОР', text: 'Знакомимся, обсуждаем цели и направление — вуз, школа-пансион, летний лагерь или курсы. Подписываем договор.' },
      { title: 'ПРОФОРИЕНТАЦИЯ', text: 'Проводим профориентацию, подбираем учебные заведения по критериям клиента: страна, специальность, бюджет, возраст.' },
      { title: 'ПОДГОТОВКА ДОКУМЕНТОВ', text: 'Помогаем собрать полный пакет: паспорт, транскрипты, рекомендации, мотивационное письмо, резюме, портфолио.' },
      { title: 'ПОДАЧА И ЗАЧИСЛЕНИЕ', text: 'Заполняем заявки, подаём документы, ведём переписку с учебными заведениями, получаем офер о зачислении.' },
      { title: 'ВИЗА И АДАПТАЦИЯ', text: 'Сопровождаем получение студенческой визы. Помогаем с выбором жилья и подготовкой к переезду.' },
      { title: 'ОТЪЕЗД И СТАРТ', text: 'Провожаем в новую жизнь. Поддержка 2 недели после приезда.' }
    ]
  },
  uk: {
    eyebrow: 'Process',
    title: 'Етапи нашої роботи з вами',
    subtitle: 'Команда STUDYGRI бере на себе всю роботу — від першої консультації до початку навчання',
    seeAll: 'Дивитися всі 18 кроків нашого процесу',
    steps: [
      { title: 'ЗНАЙОМСТВО І ДОГОВІР', text: 'Знайомимося, обговорюємо цілі та напрямок — виш, школа-пансіон, літній табір або курси. Підписуємо договір.' },
      { title: 'ПРОФОРІЄНТАЦІЯ', text: 'Проводимо профорієнтацію, підбираємо навчальні заклади за критеріями клієнта: країна, спеціальність, бюджет, вік.' },
      { title: 'ПІДГОТОВКА ДОКУМЕНТІВ', text: 'Допомагаємо зібрати повний пакет: паспорт, транскрипти, рекомендації, мотиваційний лист, резюме, портфоліо.' },
      { title: 'ПОДАЧА ТА ВСТУП', text: 'Заповнюємо заявки, подаємо документи, ведемо листування з навчальними закладами, отримуємо офер про зарахування.' },
      { title: 'ВІЗА ТА АДАПТАЦІЯ', text: 'Супроводжуємо отримання студентської візи. Допомагаємо з вибором житла та підготовкою до переїзду.' },
      { title: 'ВІД\u2019ЇЗД ТА СТАРТ', text: 'Проводжаємо в нове життя. Підтримка 2 тижні після приїзду.' }
    ]
  },
  en: {
    eyebrow: 'Process',
    title: 'How we work with you',
    subtitle: 'The STUDYGRI team handles everything — from the first consultation to the start of studies',
    seeAll: 'See all 18 steps of our process',
    steps: [
      { title: 'INTRODUCTION & CONTRACT', text: 'We get to know you, discuss goals and direction — university, boarding school, summer camp or courses. Then sign the contract.' },
      { title: 'CAREER GUIDANCE', text: 'We run a career assessment and select institutions by your criteria: country, major, budget, age.' },
      { title: 'DOCUMENT PREP', text: 'We help collect the full package: passport, transcripts, recommendations, motivation letter, CV, portfolio.' },
      { title: 'APPLICATION & OFFER', text: 'We fill in applications, submit documents, handle correspondence with institutions and secure the admission offer.' },
      { title: 'VISA & ADAPTATION', text: 'We guide the student visa process. Help with housing choice and pre-departure preparation.' },
      { title: 'DEPARTURE & START', text: 'We send you off into a new life. 2 weeks of support after arrival.' }
    ]
  },
  ar: {
    eyebrow: 'العملية',
    title: 'مراحل عملنا معك',
    subtitle: 'فريق STUDYGRI يتولى كل شيء — من الاستشارة الأولى إلى بدء الدراسة',
    seeAll: 'عرض جميع خطوات العملية الـ 18',
    steps: [
      { title: 'التعارف والعقد', text: 'نتعرف على أهدافك ونحدد الاتجاه — جامعة أو مدرسة داخلية أو معسكر صيفي أو دورات. ثم نوقع العقد.' },
      { title: 'التوجيه المهني', text: 'نجري تقييمًا مهنيًا ونختار المؤسسات وفق معاييرك: الدولة، التخصص، الميزانية، العمر.' },
      { title: 'تحضير الوثائق', text: 'نساعد في تجميع الحزمة الكاملة: جواز السفر، الكشوف، التوصيات، خطاب الدوافع، السيرة الذاتية، ملف الأعمال.' },
      { title: 'التقديم والقبول', text: 'نملأ الطلبات ونقدم الوثائق ونتولى المراسلات مع المؤسسات ونحصل على عرض القبول.' },
      { title: 'التأشيرة والتكيف', text: 'نرافقك خلال إجراءات التأشيرة الطلابية. ونساعد في اختيار السكن والاستعداد للسفر.' },
      { title: 'السفر والانطلاق', text: 'نودعك إلى حياة جديدة. دعم لمدة أسبوعين بعد الوصول.' }
    ]
  },
  it: {
    eyebrow: 'Processo',
    title: 'Le fasi del nostro lavoro con te',
    subtitle: 'Il team STUDYGRI si occupa di tutto — dalla prima consulenza all\u2019inizio degli studi',
    seeAll: 'Vedi tutti i 18 passaggi del nostro processo',
    steps: [
      { title: 'CONOSCENZA E CONTRATTO', text: 'Ci conosciamo, definiamo obiettivi e direzione — università, collegio, campo estivo o corsi. Firmiamo il contratto.' },
      { title: 'ORIENTAMENTO', text: 'Valutiamo il profilo e selezioniamo gli istituti in base a: paese, indirizzo, budget, età.' },
      { title: 'PREPARAZIONE DEI DOCUMENTI', text: 'Aiutiamo a raccogliere il pacchetto completo: passaporto, pagelle, referenze, lettera motivazionale, CV, portfolio.' },
      { title: 'CANDIDATURA E AMMISSIONE', text: 'Compiliamo le application, inviamo i documenti, gestiamo la corrispondenza e otteniamo la lettera di ammissione.' },
      { title: 'VISTO E ADATTAMENTO', text: 'Seguiamo l\u2019iter del visto studente. Aiutiamo nella scelta dell\u2019alloggio e nella preparazione alla partenza.' },
      { title: 'PARTENZA E AVVIO', text: 'Ti accompagniamo verso una nuova vita. Supporto 2 settimane dopo l\u2019arrivo.' }
    ]
  },
  zh: {
    eyebrow: '流程',
    title: '我们与您合作的各个阶段',
    subtitle: 'STUDYGRI 团队全程负责 — 从首次咨询到开学',
    seeAll: '查看完整的 18 步流程',
    steps: [
      { title: '初识与签约', text: '了解目标与方向（大学、寄宿学校、夏令营或课程），随后签订合同。' },
      { title: '职业规划', text: '进行职业测评，按国家、专业、预算、年龄等标准为您筛选院校。' },
      { title: '材料准备', text: '协助准备完整材料包：护照、成绩单、推荐信、动机信、简历、作品集。' },
      { title: '申请与录取', text: '填写申请、提交材料、与院校沟通，获取录取通知书。' },
      { title: '签证与适应', text: '协助办理学生签证，协助选择住房和行前准备。' },
      { title: '出发与开学', text: '送您开启新生活。抵达后提供 2 周支持。' }
    ]
  },
  es: {
    eyebrow: 'Proceso',
    title: 'Las etapas de nuestro trabajo contigo',
    subtitle: 'El equipo STUDYGRI se encarga de todo — desde la primera consulta hasta el inicio de los estudios',
    seeAll: 'Ver los 18 pasos de nuestro proceso',
    steps: [
      { title: 'PRESENTACIÓN Y CONTRATO', text: 'Nos conocemos, definimos objetivos y rumbo — universidad, internado, campamento de verano o cursos. Firmamos el contrato.' },
      { title: 'ORIENTACIÓN', text: 'Evaluamos el perfil y seleccionamos centros según país, especialidad, presupuesto y edad.' },
      { title: 'PREPARACIÓN DE DOCUMENTOS', text: 'Ayudamos a reunir el paquete completo: pasaporte, expedientes, recomendaciones, carta de motivación, CV, portafolio.' },
      { title: 'SOLICITUD Y ADMISIÓN', text: 'Rellenamos las solicitudes, presentamos los documentos, gestionamos la correspondencia y conseguimos la carta de admisión.' },
      { title: 'VISADO Y ADAPTACIÓN', text: 'Acompañamos en el visado de estudiante. Ayudamos con la elección de alojamiento y la preparación previa al viaje.' },
      { title: 'PARTIDA Y COMIENZO', text: 'Te despedimos hacia una nueva vida. Soporte de 2 semanas tras la llegada.' }
    ]
  },
  pl: {
    eyebrow: 'Proces',
    title: 'Etapy naszej współpracy z Tobą',
    subtitle: 'Zespół STUDYGRI zajmuje się wszystkim — od pierwszej konsultacji do rozpoczęcia studiów',
    seeAll: 'Zobacz wszystkie 18 kroków naszego procesu',
    steps: [
      { title: 'POZNANIE I UMOWA', text: 'Poznajemy się, omawiamy cele i kierunek — uczelnia, szkoła z internatem, obóz letni lub kursy. Podpisujemy umowę.' },
      { title: 'DORADZTWO ZAWODOWE', text: 'Robimy ocenę zawodową i dobieramy uczelnie wg kryteriów: kraj, kierunek, budżet, wiek.' },
      { title: 'PRZYGOTOWANIE DOKUMENTÓW', text: 'Pomagamy zebrać pełen pakiet: paszport, świadectwa, rekomendacje, list motywacyjny, CV, portfolio.' },
      { title: 'APLIKACJA I PRZYJĘCIE', text: 'Wypełniamy wnioski, składamy dokumenty, prowadzimy korespondencję z uczelniami i uzyskujemy ofertę przyjęcia.' },
      { title: 'WIZA I ADAPTACJA', text: 'Wspieramy w uzyskaniu wizy studenckiej. Pomagamy w wyborze mieszkania i przygotowaniach do wyjazdu.' },
      { title: 'WYJAZD I START', text: 'Wyprawiamy Cię w nowe życie. Wsparcie 2 tygodnie po przyjeździe.' }
    ]
  }
};
